import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../actions/authActions';
import * as sessionActions from '../../actions/sessionActions';
import * as profileActions from '../../actions/profileActions';
import * as policyActions from '../../actions/policyActions';
import * as registrationActions from '../../actions/registrationActions';
import { push } from 'connected-react-router';
import { profileSelector, authSelector } from '../../selectors';

import { Container, Grid, Button, Header, Form, Message } from 'semantic-ui-react';

class LegacyUserPage extends Component {
	constructor(props) {
		super(props);

		const { legacyUsername, username, auth } = props;
		const { email } = props.profile;

		let initialUsername = legacyUsername === username && (email || '').length > 0 ? email : '';
		auth.username = initialUsername;
		this.props.actions.updateUserAuth(auth);

		this.onUserChange = this.onUserChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	onUserChange(e) {
		e.preventDefault();
		const auth = { ...this.props.auth };
		auth[e.target.name] = e.target.value;
		this.props.actions.updateUserAuth(auth);
	}

	async onSubmit(e) {
		e.preventDefault();
		const { actions, auth } = this.props;
		await actions.changeLegacyUser(auth.username);
		actions.push('/');
	}

	render() {
		const { username, loading, error } = this.props.auth;

		let errorMessage;
		if (error) {
			const content = Array.isArray(error) ? error.map((e, index) => <div key={index}>{`${e}`}</div>) : error;
			errorMessage = <Message error header='Username change Failed' content={content} />;
		}
		return (
			<div className='auth forgot'>
				<Container>
					<Grid columns='equal'>
						<Grid.Column width={7} only='tablet computer' />
						<Grid.Column computer={8} mobile={16} tablet={8}>
							<Form onSubmit={this.onSubmit} loading={loading} error>
								<Header as='h1' textAlign='center' content='Change Username' />
								<Message>
									<Message.Header>Welcome to the new site!</Message.Header>
									<p>Our new site requires username to be an email address. Please enter your email address. Next time you login you will use your email address.</p>
								</Message>
								<Header as='h4' content='Enter your Email Address.' />

								{errorMessage}
								<Form.Field>
									<input name='username' placeholder='Email Address' onChange={this.onUserChange} value={username} type="email"/>
								</Form.Field>
								<Form.Field>
									<Button basic fluid type='submit'>
										Change
									</Button>
								</Form.Field>
							</Form>
						</Grid.Column>
					</Grid>
				</Container>
			</div>
		);
	}
}

LegacyUserPage.propTypes = {
	profile: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	auth: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		profile: profileSelector(state),
		auth: authSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		actions: {
			...bindActionCreators({ push }, dispatch),
			...bindActionCreators(authActions, dispatch),
			...bindActionCreators(profileActions, dispatch),
			...bindActionCreators(policyActions, dispatch),
			...bindActionCreators(sessionActions, dispatch),
			...bindActionCreators(registrationActions, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LegacyUserPage);
